import { ReactElement } from 'react';
import { ListIcon, LogoutIcon, RefreshIcon } from '@root/src/assets/images';
import { MenuDangerOption } from '@root/src/app/designSystem/contextMenu/menuOptions';
import MenuButton from './menuButton';
import Lang from '@lang/en';
import { MenuVariationI } from '.';
import ContextMenu, {
  OptionI,
} from '@root/src/app/designSystem/contextMenu/contextMenu';

const MenuDesktop = ({
  handleLogout,
  handleGoToDashboard,
  refreshOTP,
}: MenuVariationI): ReactElement => {
  const options: Array<OptionI> = [
    {
      type: 'component',
      details: {
        'data-testid': 'healthcheck-navbar-menu-orders',
        onClick: handleGoToDashboard,
        icon: <ListIcon />,
        label: Lang.healthCheckMenuOrdersOption,
      },
    },
    {
      type: 'component',
      details: {
        'data-testid': 'healthcheck-navbar-menu-refreshOtp',
        onClick: refreshOTP,
        icon: <RefreshIcon />,
        noFill: true,
        label: Lang.healthCheckMenuRefreshOTPOption,
      },
    },
    { type: 'divider' },
    {
      type: 'component',
      details: {
        'data-testid': 'healthcheck-navbar-menu-logout',
        component: MenuDangerOption,
        onClick: handleLogout,
        icon: <LogoutIcon />,
        label: Lang.healthCheckMenuLogoutOption,
      },
    },
  ];

  return (
    <ContextMenu
      options={options}
      menuButton={MenuButton}
      data-testid="healthcheck-navbar-menu-icon"
    />
  );
};

export default MenuDesktop;
